import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/global.less'
import Fragment from 'vue-fragment'

Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
import BaseUrl from './utils/httpUrl'
import VueAMap from 'vue-amap';
import {Message} from 'element-ui'
import animated from 'animate.css'
import {sortHeaders ,getTokenJM} from './utils/HeaderKey'

VueAMap.initAMapApiLoader({
    // key: '05405266d391360f45377a522cda9c6a',
    key: '334b730107eda5898a848b4dd47e8326',
    //插件
    plugin: [
        "AMap.Autocomplete",// 输入提示插件 
        "AMap.PlaceSearch",// POI搜索插件
        "AMap.Scale",// 右下角缩略图插件 比例尺
        "AMap.OverView",// 地图鹰眼插件
        "AMap.ToolBar",// 地图工具条
        "AMap.MapType",// 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        "AMap.PolyEditor",// 编辑 折线多，边形
        "AMap.CircleEditor",// 圆形编辑器插件
        "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
        "AMap.Geocoder",// 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
        "AMap.AMapUI",// UI组件
    ],
    uiVersion: '1.0.11', 
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});
Vue.use(VueAMap);
Vue.use(animated)


const showStatus = (status) => {
  let message = ''
  switch (status) {
      case 400:
          message = '请求错误(400)'
          break
      case 401:
          message = '此账户可能已在别处登录，请重新登录'
          break
      case 403:
          message = '拒绝访问(403)'
          break
      case 404:
          message = '请求出错(404)'
          break
      case 408:
          message = '请求超时(408)'
          break
      case 500:
          message = '服务器错误(500)'
          break
      case 501:
          message = '服务未实现(501)'
          break
      case 502:
          message = '网络错误(502)'
          break
      case 503:
          message = '服务不可用(503)'
          break
      case 504:
          message = '网络超时(504)'
          break
      case 505:
          message = 'HTTP版本不受支持(505)'
          break
      default:
          message = `连接出错(${status})!`
  }
  return `${message}，请检查网络或联系管理员！`
}
const $webhttp = axios.create({
  //   baseURL: process.env.VUE_APP_TITLE,
    baseURL: BaseUrl,
    headers: {
        get: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        post: {
            'Content-Type': 'application/json;charset=utf-8'
        }
    },
    timeout: 100000*20
  })
$webhttp.interceptors.request.use((config) => {

        let token = sessionStorage.getItem('user_token') ? sessionStorage.getItem('user_token') : "";
        if(token){
            const uint8Array = Uint8Array.from(token .match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
            const decoder = new TextDecoder();
            const str = decoder.decode(uint8Array);
            
            config.headers.user_token =  str;
            let headers =  sortHeaders({type:3,user_token:str});
            delete headers.apiToken;
            config.headers={
                user_token:token,
                ...headers
            }
        }
        return config
    }, (error) => {
        return Promise.resolve(error)
    },
)
$webhttp.interceptors.response.use((config)=>{
    const status = config.status
    let msg = '';
    if (status !== 200) {       
        // 处理http错误，抛到业务代码
        msg = showStatus(config.data.code); 
        Message.error(msg);        
    } 
    return config.data;
  } ,(error) => {
    return Promise.resolve(error)
})
const $http = axios.create({
  //   baseURL: process.env.VUE_APP_TITLE,
    baseURL: BaseUrl,
    headers: {
        get: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        post: {
            'Content-Type': 'application/json;charset=utf-8'
        }
    },
    timeout: 100000*20
  })
$http.interceptors.request.use((config) => {

        let token = sessionStorage.getItem('user_token') ? sessionStorage.getItem('user_token') : "";
        if(token){
            const uint8Array = Uint8Array.from(token .match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
            const decoder = new TextDecoder();
            const str = decoder.decode(uint8Array);
            
            config.headers.user_token =  str;
            let headers =  sortHeaders({type:3,user_token:str});
            delete headers.apiToken;
            config.headers={
                user_token:token,
                ...headers
            }
        }
        return config
    }, (error) => {
        return Promise.resolve(error)
    },
)
$http.interceptors.response.use((config)=>{
      const status = config.status
      let msg = '';
      if (status !== 200) {       
            // 处理http错误，抛到业务代码
          msg = showStatus(config.data.code); 
          Message.error(msg);        
      } else {     
          if (config.data.code == 401 ||config.data.code == 403) {
                //   Message.success('自动退出系统！')
                //   Message.error(config.data.message);
                  localStorage.clear();
                  sessionStorage.clear()
                  router.push('/login')
              }
          }
           return config.data;
  } ,(error) => {
    return Promise.resolve(error)
})
Vue.prototype.$http=$http;
Vue.prototype.$webhttp=$webhttp;

Vue.use(ElementUI);
Vue.use(Fragment.Plugin)
Vue.prototype.$getTokenJM = getTokenJM;
  
new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
